import React, { useCallback } from 'react';

import { SELECTIVE_FWD_FIELDS } from '../../common/fields';
import * as actions from '../../containers/General/generalActions';

import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import Label from '../Controls/Label/Label';
import Description from '../Controls/Description/Description';
import RangeOrSubnet from '../RangeOrSubnet/RangeOrSubnet';

import styles from './SelectiveForwarding.module.css';
import { Info, Toggle, Tooltip } from '@silverfort/sf-components';

const { SELECTIVE_FORWARDING, EXCLUDE_EXCHANGE_SERVERS } = SELECTIVE_FWD_FIELDS;

const SelectiveForwarding = ({ fields, dispatch, maxSelectedSubnets }) => {
    const selectiveFwdFields = fields[SELECTIVE_FORWARDING.ID];
    const excludeExchangeField = fields[EXCLUDE_EXCHANGE_SERVERS.ID];

    const dispatchUpdate = useCallback(
        (tabKey, index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_SELECTIVE_FWD_FIELD,
                payload: { fieldId: tabKey, index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchExchangeServers = useCallback(() => {
        dispatch({ type: actions.SWITCH_EXCHANGE_SERVERS });
    }, [dispatch]);

    const dispatchAddRangeOrSubnet = useCallback(() => {
        dispatch({ type: actions.ADD_SELECTIVE_FWD_VALUE });
    }, [dispatch]);

    const dispatchRemoveRangeOrSubnet = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_SELECTIVE_FWD_VALUE, payload: index });
        },
        [dispatch]
    );

    return (
        <>
            {selectiveFwdFields && (
                <div className={styles.header}>
                    <Label value={selectiveFwdFields.name} />
                    <div className="flex flex-col w-full gap-2 justify-center">
                        <div className={styles.description + ' mt-0'}>
                            <Description value={selectiveFwdFields.desc} />
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="mt-0.5">
                                <Toggle onChange={dispatchExchangeServers} checked={excludeExchangeField.value} />
                            </div>

                            <div className="flex text-13 text-sf-gray-700">
                                <span>{excludeExchangeField.name}</span>
                            </div>
                            <div className="w-8">
                                <Tooltip title="If enabled, the exchange server traffic will be monitored but not protected. By default, all exchange server traffic is protected.">
                                    <Info />
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    {selectiveFwdFields.warning && (
                        <div className={styles.warningText}>{selectiveFwdFields.warning}</div>
                    )}

                    {selectiveFwdFields.value.map((field, index) => {
                        return (
                            <ArrayContainer
                                key={SELECTIVE_FORWARDING.ID + index}
                                header="Selective Forwarding"
                                topSpace={false}
                                remove={() => dispatchRemoveRangeOrSubnet(index)}>
                                <RangeOrSubnet
                                    field={field}
                                    changedFunc={(fId, val) => dispatchUpdate(SELECTIVE_FORWARDING.ID, index, fId, val)}
                                    maxSelectedSubnets={maxSelectedSubnets}
                                />
                            </ArrayContainer>
                        );
                    })}

                    <div className={selectiveFwdFields.value.length === 0 ? styles.empty : ''}>
                        <Button onClick={dispatchAddRangeOrSubnet}>+ Add Range, IP or Subnet</Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(SelectiveForwarding);
